import { useRef, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { Editor } from "@tinymce/tinymce-react";
import { ThemeContext } from "../../../theme/ThemeContext";

const ObjectiveRow = ({ obj, onToggleRemove, onChange }) => {
  const editorRef = useRef(null);
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <div
      style={{
        opacity: obj.removed ? 0.5 : 1,
        marginBottom: "1rem",
      }}
    >
      <Row className="mb-3 position-relative">
        <Col md={12}>
          <input
            className="form-control custom-input custom-title-color"
            value={obj.label}
            disabled
            style={{
              textDecoration: obj.removed ? "line-through" : "none",
            }}
          />
          <Button
            className="p-1 px-2 custom-hover position-absolute m-2 me-3 custom-title-color  "
            style={{
              top: "0.25rem",
              right: "0.5rem",
            
            }}
            title={obj.removed ? "Restore" : "Remove"}
            onClick={() => onToggleRemove(obj.id)}
          >
            <FaTimes
              className={obj.removed ? "text-secondary" : "text-danger"}
              size={18}
            />
          </Button>
        </Col>
      </Row>

      {/* TinyMCE Editor */}
      <Row className="mb-4">
        <Col md={12}>
  <Editor
  key={theme}
  tinymceScriptSrc="/tinymce/tinymce.min.js"
  value={obj.text}
  disabled={obj.removed}
  onInit={(e, editor) => (editorRef.current = editor)}
  onEditorChange={(content) => onChange(obj.id, content)}
  init={{
    menubar: false,
    plugins: ["lists", "link", "code", "autoresize"],
    toolbar:
      "bold italic underline | bullist numlist | alignleft aligncenter alignright | code",
    skin: isDark ? "oxide-dark" : "oxide", 
    content_css: isDark ? "dark" : "default",
    content_style: `
      body {
        background-color: ${isDark ? "#191919" : "#ffffff"};
        color: ${isDark ? "#ffffff" : "#000000"};
        font-family: 'Trebuchet MS';
        font-size: 14px;
      }
      .tox-toolbar, .tox-toolbar__primary {
        background-color: ${isDark ? "#191919" : "#f8f9fa"} !important;
      }
    `,
    min_height: 150,
    max_height: 500,
    autoresize_bottom_margin: 20,
  }}
/>


        </Col>
      </Row>
    </div>
  );
};

export default ObjectiveRow;
